module.exports = __webpack_public_path__ + "static/media/siddharth-vijayawada-trip-02.85a58769.png";